import React from "react";

import "./eligibility-flow.scss";
import NavStepper from "./NavStepper";

const EligibilityFlowLeftContainer = ({ currentPath }) => {
  const showLogoForPaths = ["eligibility-success", "eligibility-error", "eligibility-age-error"];

  return (
    <div
      className={`col-md-12 col-lg-12 d-flex flex-column justify-content-between h-100 border-0 rounded ${
        currentPath === "eligibility-success"
          ? "eligibility-success-div"
          : currentPath === "eligibility-error" || currentPath === "eligibility-age-error"
          ? "eligibility-error-div"
          : "background-image-div"
      }`}
    >
      {showLogoForPaths.includes(currentPath) ? (
        <img
          className="logo-img py-4 px-4 mx-0"
          src="/images/logo-white.png"
          alt=""
        />
      ) : (
        <img
          className="logo-img py-4 px-4 mx-0"
          src="/images/logo.png"
          alt=""
        />
      )}
      <div
        className={`py-4 px-4 mx-0 border gray-border rounded-bottom border-top-0 mt-auto ${
          currentPath === "eligibility-success" ||
          currentPath === "eligibility-error" ||
          currentPath === "eligibility-age-error"
            ? "blurred-bg"
            : "bg-white"
        }`}
      >
        <NavStepper currentPath={currentPath} isTopMenu={false}/>
      </div>
    </div>
  );
};

export default EligibilityFlowLeftContainer;
